import { UtilityButton } from '@lego/connect-components-react';
import { useState } from 'react';

const CopySimulationLinkButton = () => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleCopyLink = async (): Promise<void> => {
    await navigator.clipboard.writeText(window.location.href);
    setIsLinkCopied(true);
    window.setTimeout(() => setIsLinkCopied(false), 2000);
  };

  const label = isLinkCopied ? 'Copied!' : 'Copy link';

  return (
    <UtilityButton
      aria-label={label}
      iconName="bring-backward"
      size="small"
      onClick={handleCopyLink}
    >
      {label}
    </UtilityButton>
  );
};

export default CopySimulationLinkButton;
